import type {
  MembershipApiModel,
  MembershipExpandedCommon,
} from '../../../api/membership';
import type {
  EditionExpandedCommon,
  ProgramApiModel,
} from '../../../api/program';
import type {MaybeExpanded} from '../../../api/types';
import type {ProposedMembership} from './types';

import {membershipExpandCommon} from '../../../api/membership';
import {membershipFetchList} from '../../../services/entity-action/membership/membership.fetch-list';
import {findLastIndex} from '../../array';

export const getProposedMembership = async (
  program: ProgramApiModel,
): Promise<ProposedMembership | undefined> => {
  const membershipResponse = (await membershipFetchList.asClient({
    params: {
      expand: membershipExpandCommon,
      limit: 1,
      query: [
        ['program_id', '==', program._id],
        ['expired', '==', null],
        ['status', '==', 'proposed' as MembershipApiModel['status']],
      ],
    },
  })) as MembershipExpandedCommon[];

  const [membership] = membershipResponse;

  if (!membership) {
    return;
  }

  let programLastEdition: MaybeExpanded<EditionExpandedCommon> | undefined;

  if (membership.program) {
    const editionIndex = findLastIndex(
      membership.program?.editions || [],
      edition => edition?.status === 'active',
    );

    programLastEdition =
      editionIndex >= 0
        ? (membership.program?.editions || [])[editionIndex]
        : undefined;
  }

  return {
    ...membership,
    course: membership.course
      ? {
          ...membership.course,
          programLastEdition,
        }
      : null,
  };
};
